// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ZXax","title":"Images45_title__2FMrc","images":"Images45_images__3pEwO"};